import type { ShippingZone } from '@nucleus-commerce/api-client/admin';
import { ApiError } from '@nucleus-commerce/api-client/transport';

/** Countries already covered by another zone of the store; the picker greys them out. */
export function takenCountries(
  zones: readonly ShippingZone[],
  exceptId?: string,
): Map<string, string> {
  const taken = new Map<string, string>();
  for (const zone of zones) {
    if (zone.id === exceptId) continue;
    for (const code of zone.countries) taken.set(code, zone.name);
  }
  return taken;
}

export interface ZoneErrorTarget {
  field: 'countries' | 'root.server';
  key: string;
  values?: Record<string, unknown>;
}

/** 422 with `meta.countries` names the clashing countries; it lands on the countries field. */
export function zoneErrorTarget(error: unknown): ZoneErrorTarget | null {
  if (!(error instanceof ApiError)) return null;
  if (Array.isArray(error.meta.countries)) {
    const countries = error.meta.countries.filter((c): c is string => typeof c === 'string');
    return {
      field: 'countries',
      key: 'shipping:zone.errors.countriesTaken',
      values: { countries },
    };
  }
  return null;
}

/** A price in the wrong currency comes back with `meta.currency`. */
export function rateCurrencyError(error: unknown): { key: string; currency: string } | null {
  if (!(error instanceof ApiError) || typeof error.meta.currency !== 'string') return null;
  return { key: 'shipping:rate.errors.currency', currency: error.meta.currency };
}

/** Region restrictions are per country; the count is what the card shows. */
export function regionRestrictionCount(zone: Pick<ShippingZone, 'regions'>): number {
  return zone.regions ? Object.keys(zone.regions).length : 0;
}
